import styled from 'styled-components'

const HeroSectionStyle = styled.section`
	--cocktailsHeroTextMTop: var(--sp3x);

	margin-top: var(--subSectionDistance);

	.cocktails-hero-text {
		margin-top: var(--cocktailsHeroTextMTop);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--cocktailsHeroTextMTop: var(--sp2x);
	}
`

export default HeroSectionStyle
